{
  "common.close": "بستن",
  "common.athleteFallback": "ورزشکار {id}",
  "splash.title": "{app} — نمایش متحرک فعالیت‌ها",
  "splash.tagline": "نقشه‌ی متحرک برای داده‌های&nbsp;Strava شما",
  "splash.demo": "نمونه",
  "tab.query.title": "نقشه‌ی {name}",
  "tab.query.heading": "جست‌وجوی فعالیت‌ها:",
  "tab.query.optDays": "روزهای اخیر",
  "tab.query.optActivities": "فعالیت‌های اخیر",
  "tab.query.optIds": "شناسه‌های فعالیت",
  "tab.query.optDates": "بازه‌ی تاریخ",
  "tab.query.idsPlaceholder": "شناسه‌های فعالیت را اینجا وارد کنید",
  "tab.query.after": "پس از:",
  "tab.query.before": "پیش از:",
  "tab.query.autozoom": "بزرگ‌نمایی خودکار <i class=\"hf hf-bullseye\"></i> روی نتیجه پس از دریافت",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> جست‌وجو",
  "tab.query.createAccount": "حساب بسازید و/یا وارد شوید.",
  "tab.query.sports": "ورزش‌ها:",
  "tab.query.allSports": "همه ورزش‌ها",
  "tab.query.sportsExcept": "همه به جز",
  "tab.query.sportsNone": "هیچ‌کدام",
  "tab.query.loadingSports": "در حال بارگیری ورزش‌ها…",
  "tab.query.sportsFailed": "بارگیری ورزش‌های این نقشه ممکن نشد",
  "tab.query.noSports": "هنوز فعالیتی نیست",
  "tab.activities.title": "فعالیت‌های نمایش‌داده‌شده",
  "tab.activities.clearSelection": "پاک کردن انتخاب",
  "tab.activities.renderSelected": "نمایش انتخاب‌شده‌ها",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> بزرگ‌نمایی روی انتخاب",
  "tab.controls.title": "تنظیمات لایه",
  "tab.controls.timescale": "مقیاس زمانی <i>&tau;</i>",
  "tab.controls.timescaleHint": "سرعت پخش",
  "tab.controls.period": "دوره <i>T</i>",
  "tab.controls.periodHint": "فعالیت ~ مدل",
  "tab.controls.dotSize": "اندازه‌ی نقطه",
  "tab.controls.pathWidth": "پهنای مسیر",
  "tab.controls.pathWidthHint": "صفر مسیرها را پنهان می‌کند",
  "tab.controls.colors": "رنگ‌ها",
  "tab.controls.colorsHint": "چرخاندن پالت رنگ",
  "tab.controls.shadows": "سایه‌ها",
  "tab.profile.loginTitle": "ورود",
  "tab.profile.anonNote": "با Strava وارد شوید تا فعالیت‌های خودتان را ببینید و حساب Heatflask خود را مدیریت کنید.",
  "tab.profile.loginLink": "ورود با Strava",
  "tab.profile.editOnStrava": "ویرایش نمایه در Strava",
  "tab.profile.indexNote": "خلاصه‌ی فعالیت‌های شما را برای دسترسی سریع نمایه‌سازی می‌کنیم.",
  "tab.profile.viewIndex": "دیدن نمایه",
  "tab.profile.sharedMaps": "نقشه‌های اشتراکی",
  "tab.profile.sharedMapsNote": "خاموش: فقط خودتان فعالیت‌هایتان را در Heatflask می‌بینید. روشن: هر کسی که پیوند نقشه‌ی شما را داشته باشد، فعالیت‌هایی را که در Strava عمومی کرده‌اید می‌بیند. فعالیت‌های خصوصی شما در هر حال خصوصی می‌مانند. <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">حریم خصوصی چگونه کار می‌کند</a>",
  "tab.profile.logout": "خروج",
  "tab.profile.deleteAccount": "حذف حساب",
  "tab.profile.deleteConfirm": "حساب Heatflask خود را حذف می‌کنید؟\n\nاین کار فعالیت‌های نمایه‌شده‌ی شما را پاک می‌کند و دسترسی Heatflask به داده‌های Strava شما را لغو می‌کند. قابل بازگشت نیست.",
  "tab.profile.languageHeading": "زبان",
  "tab.profile.languageAuto": "خودکار",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">در اصلاح یا افزودن ترجمه‌ها به ما کمک کنید!</a>",
  "tab.profile.unitsHeading": "واحدها",
  "tab.profile.unitsAuto": "خودکار",
  "tab.profile.unitsMetric": "متریک (کیلومتر، متر)",
  "tab.profile.unitsImperial": "امپریال (مایل، فوت)",
  "tab.profile.textSizeHeading": "اندازه‌ی متن",
  "tab.profile.textSmaller": "کوچک‌تر",
  "tab.profile.textReset": "عادی",
  "tab.profile.textLarger": "بزرگ‌تر",
  "tab.profile.mapDefaultsHeading": "پیش‌فرض‌های نقشه",
  "tab.profile.mapDefaultsNote": "هر بار نقشه‌ای را باز می‌کنید که پیوندش تنظیمات خودش را ندارد، با این نقشه‌ی پایه، ناهمواری و تنظیمات لایه شروع شود. پیوندهایی که به اشتراک می‌گذارید همچنان دقیقاً همان چیزی را نشان می‌دهند که شما می‌بینید.",
  "tab.profile.mapDefaultsSave": "ذخیره به‌عنوان پیش‌فرض من",
  "tab.profile.mapDefaultsForget": "فراموش کن",
  "tab.info.title": "راهنما",
  "tab.info.controlsHeading": "کنترل‌ها",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + کشیدن",
  "tab.info.shiftDragDesc": "فعالیت‌ها را درون یک کادر انتخاب کنید. در صفحه‌ی لمسی، ابتدا <i class=\"hf-object-group\"></i> را بزنید و سپس با یک انگشت بکشید. آخرین فعالیت انتخاب‌شده جزئیاتش را نشان می‌دهد و فهرست فعالیت‌ها تا آن پیمایش می‌شود.",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + کشیدن",
  "tab.info.ctrlDragDesc": "چرخاندن و کج کردن سه‌بعدی نقشه، یا از دو انگشت استفاده کنید",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "باز یا بسته کردن نوار کناری",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "زبانه‌ی قبلی یا بعدی نوار کناری",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "بستن نوار کناری",
  "tab.info.liveUrlHeading": "نشانی زنده",
  "tab.info.liveUrlDesc": "نمای نقشه و تنظیمات پویانمایی در نشانی صفحه نگه داشته می‌شوند، پس هر کسی که آن را با او به اشتراک بگذارید همان نما را می‌بیند.",
  "tab.info.videoHeading": "خروجی ویدیو",
  "tab.info.videoDesc": "دکمه‌ی <i class=\"hf-video-camera\"></i> پویانمایی را به‌صورت MP4 ضبط می‌کند: آن را بزنید، کادر را روی بخشی از نقشه که می‌خواهید تنظیم کنید و دوباره بزنید تا ضبط شود. یک دور کامل از پویانمایی ضبط می‌شود تا ویدیو بی‌درز تکرار شود؛ دوری که از {max} ثانیه (طولانی‌ترین ویدیویی که Strava می‌پذیرد) بلندتر باشد در {max} بریده می‌شود.",
  "tab.info.contributeHeading": "مشارکت",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> حمایت در GitHub",
  "tab.info.contactsHeading": "تماس",
  "map.basemapAndTerrain": "نقشه‌ی پایه و ناهمواری",
  "map.pauseAnimation": "توقف پویانمایی",
  "map.resumeAnimation": "ادامه‌ی پویانمایی",
  "capture.record": "ضبط ویدیو (دور {period} ثانیه‌ای)",
  "capture.recordTruncated": "ضبط ویدیو (هر دور {period} ثانیه است؛ فقط {max} ثانیه‌ی اول ضبط می‌شود)",
  "capture.recordArea": "ضبط ناحیه‌ی درون کادر",
  "capture.stop": "توقف ضبط",
  "capture.selectionTooSmall": "ناحیه‌ی انتخاب‌شده خیلی کوچک است",
  "capture.saved": "{name} ذخیره شد ({size})",
  "capture.cancelled": "ضبط لغو شد",
  "capture.failed": "ضبط ناموفق بود: {error}",
  "capture.loadingEncoder": "در حال بارگیری رمزگذار…",
  "capture.waitingForMap": "در انتظار بارگیری نقشه…",
  "capture.encoding": "در حال رمزگذاری… {percent}%",
  "capture.finalizing": "در حال پایان‌دادن…",
  "share.title": "اشتراک‌گذاری پیوند این نقشه",
  "share.copied": "پیوند کپی شد",
  "share.copiedUnshared": "پیوند کپی شد، اما نقشهٔ شما اشتراکی نیست و کس دیگری نمی‌تواند آن را باز کند. برای تغییر این وضعیت «نقشه‌های اشتراکی» را روشن کنید.",
  "share.unshared": "نقشهٔ شما اشتراکی نیست و کس دیگری نمی‌تواند این پیوند را باز کند. برای تغییر این وضعیت «نقشه‌های اشتراکی» را روشن کنید.",
  "share.copyThis": "این پیوند را کپی کنید:",
  "update.available": "نسخهٔ جدیدی از Heatflask در دسترس است.",
  "update.reload": "بارگذاری دوباره",
  "import.title": "در حال دریافت",
  "import.stop": "توقف",
  "import.stopping": "در حال توقف…",
  "import.contacting": "در حال ارتباط با Strava…",
  "import.countOf": "فعالیت‌ها: {received} از {total}",
  "import.count": "فعالیت‌ها: {received}",
  "import.waitStrava": "به دلیل محدودیت دانلود Strava تا {time} متوقف است. این صفحه را باز بگذارید؛ بارگذاری دوباره سرعت را بیشتر نمی‌کند.",
  "import.waitRationed": "دانلودهای سریع امروز شما تمام شد. بقیه از {time} با سرعت کمتر ادامه می‌یابد. این صفحه را باز بگذارید.",
  "import.dailyLimit": "سقف دانلود روزانه Strava پر شده است. بعد از {time} دوباره امتحان کنید.",
  "import.dailyRationed": "سهم دانلود امروز شما از Strava تمام شده است. بعد از {time} دوباره امتحان کنید.",
  "import.noActivitiesYet": "حساب Strava شما هنوز هیچ فعالیتی ندارد. یک فعالیت در Strava ثبت یا بارگذاری کنید تا اینجا نمایش داده شود.",
  "table.noActivities": "فعالیتی نیست",
  "table.untitled": "(بی‌عنوان)",
  "activities.pageTitle": "{app} — نمایه‌ی فعالیت‌ها",
  "activities.heading": "نمایه‌ی فعالیت‌ها",
  "activities.fetching": "در حال دریافت فعالیت‌ها...",
  "activities.rateLimit": "به سقف درخواست‌های Strava رسیدیم؛ ادامه در {time}",
  "activities.noData": "متأسفیم، داده‌ای نیست &#128577;",
  "activities.colServerCache": "مسیر روی سرور ذخیره شده (Mongo)",
  "activities.colBrowserCache": "مسیر در این مرورگر ذخیره شده",
  "activities.cachedServer": "مسیر {id} روی سرور ذخیره شده است",
  "activities.notCachedServer": "مسیر {id} روی سرور ذخیره نشده است",
  "activities.cachedBrowser": "مسیر {id} در این مرورگر ذخیره شده است",
  "activities.notCachedBrowser": "مسیر {id} در این مرورگر ذخیره نشده است",
  "sport.AlpineSki": "اسکی آلپاین",
  "sport.BackcountrySki": "اسکی کوهستان",
  "sport.Badminton": "بدمینتون",
  "sport.Basketball": "بسکتبال",
  "sport.Canoeing": "قایق‌رانی کانو",
  "sport.Cricket": "کریکت",
  "sport.Crossfit": "کراس‌فیت",
  "sport.Dance": "رقص",
  "sport.EBikeRide": "دوچرخه‌سواری برقی",
  "sport.Elliptical": "دستگاه الپتیکال",
  "sport.EMountainBikeRide": "دوچرخه‌سواری کوهستان برقی",
  "sport.Golf": "گلف",
  "sport.GravelRide": "دوچرخه‌سواری شنی",
  "sport.Handcycle": "دوچرخه دستی",
  "sport.HighIntensityIntervalTraining": "تمرین تناوبی شدید",
  "sport.Hike": "کوه‌پیمایی",
  "sport.IceSkate": "اسکیت روی یخ",
  "sport.InlineSkate": "اسکیت خطی",
  "sport.Kayaking": "کایاک‌سواری",
  "sport.Kitesurf": "کایت‌سرفینگ",
  "sport.MountainBikeRide": "دوچرخه‌سواری کوهستان",
  "sport.NordicSki": "اسکی صحرانوردی",
  "sport.Padel": "پدل",
  "sport.PhysicalTherapy": "فیزیوتراپی",
  "sport.Pickleball": "پیکل‌بال",
  "sport.Pilates": "پیلاتس",
  "sport.Racquetball": "راکت‌بال",
  "sport.Ride": "دوچرخه‌سواری",
  "sport.RockClimbing": "سنگ‌نوردی",
  "sport.RollerSki": "اسکی چرخ‌دار",
  "sport.Rowing": "قایقرانی",
  "sport.Run": "دویدن",
  "sport.Sail": "قایق‌رانی بادبانی",
  "sport.Skateboard": "اسکیت‌برد",
  "sport.Snowboard": "اسنوبرد",
  "sport.Snowshoe": "راه‌پیمایی با کفش برفی",
  "sport.Soccer": "فوتبال",
  "sport.Squash": "اسکواش",
  "sport.StairStepper": "دستگاه پله",
  "sport.StandUpPaddling": "پدل‌بورد ایستاده",
  "sport.Surfing": "موج‌سواری",
  "sport.Swim": "شنا",
  "sport.TableTennis": "تنیس روی میز",
  "sport.Tennis": "تنیس",
  "sport.TrailRun": "دویدن در طبیعت",
  "sport.Velomobile": "دوچرخه سرپوشیده",
  "sport.VirtualRide": "دوچرخه‌سواری مجازی",
  "sport.VirtualRow": "قایقرانی مجازی",
  "sport.VirtualRun": "دویدن مجازی",
  "sport.Volleyball": "والیبال",
  "sport.Walk": "پیاده‌روی",
  "sport.WeightTraining": "تمرین با وزنه",
  "sport.Wheelchair": "ویلچر",
  "sport.Windsurf": "موج‌سواری بادبانی",
  "sport.Workout": "تمرین",
  "sport.Yoga": "یوگا"
}
